export enum Routes {
  ROOT = '/',
  GET_STARTED = '/get-started',
  MEET_NOW = '/meet-now',
  SCHEDULE = '/schedule',
  SETTINGS = '/settings',
  SIGN_OUT = '/sign-out'
}
